import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(2, 1),
        padding: theme.spacing(4, 4, 1),
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(4, 2, 1),
        },
      },
      '& .MuiSvgIcon-colorPrimary': {
        color: theme.palette.primary.main,
      },
    },
    boxTop: {
      display: 'flex',
      flexDirection: 'column', // Cambié la dirección a column para que el título esté arriba
      alignItems: 'flex-start', // Alinea el título al inicio (izquierda)
      marginBottom: theme.spacing(2), // Espacio entre el título y el select
    },
    selectWrapper: {
      display: 'flex',
      justifyContent: 'flex-end', // Alinea el select a la derecha
      width: '100%',
    },
    boxForm: {
      '& > *': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%',
      },
    },
    tableContainer: {
      marginTop: theme.spacing(3),
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[3],
      overflowX: "auto",
      maxHeight: 500, // Ajusta la altura máxima según tu necesidad
      "&::-webkit-scrollbar": {
        width: 8,
        height: 8,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.grey[400],
        borderRadius: 4,
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[200],
      },
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(2),
      margin: theme.spacing(2, 1),
    },
    loading:{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 100,
    },
    tableHeader: {
      backgroundColor: theme.palette.primary.main,
      '& th': {
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
      },
    }
  }),
);

export default useStyles;
